export const FinstrongThresholds = {
  creditScore: {
    poor: 600,
    good: 720,
  },
  daysOfCashOnHand: {
    poor: 30,
    good: 90,
  },
  debtToIncomeRatio: {
    poor: 40,
    good: 30,
  },
  emergencySavings: {
    poor: 750,
    good: 1000,
  },
  spendToIncomeRatio: {
    poor: 110,
    good: 100,
  },
}

export const CardStatus = {
  GOOD: 'GOOD',
  FAIR: 'FAIR',
  OFF_TRACK: 'OFF TRACK',
  MISSING: 'MISSING DATA',
}
